<template>
  <a :href="post_href" target="_blank">
    <b-card :title="created_time_formatted" class="mb-2">
      <p v-html="post.message" class="px-3" />
    </b-card>
  </a>
</template>

<script lang="ts">
import FacebookApiService from "../services/FacebookApiService";

export default {
  props: {
    post: Object
  },
  computed: {
    created_time_formatted() {
      return this.post.created_time.format("MMMM Do, YYYY");
    },
    post_href() {
      var post_id = this.post.id.split("_")[1];

      return `https://www.facebook.com/${FacebookApiService.GetPageId()}/posts/${post_id}`;
    }
  }
};
</script>

<style lang="scss" scoped>
a,
a:hover {
  text-decoration: inherit;
  color: inherit;
  white-space: pre-line;
}
</style>